import { Routes, Route } from 'react-router-dom';

import Home from './Pages/Home';
import EventosListagem from './Pages/Eventos-listagem';
import EventosIntegra from './Pages/Eventos-integra';
import PalestranteIntegra from './Pages/Palestrante-integra';
import EventosAnterioresListagem from './Pages/Eventos-anteriores-listagem';
import BlogListagem from './Pages/Blog-listagem';
import BlogIntegra from './Pages/Blog-integra';
import Sobre from './Pages/Sobre';
import Contatos from './Pages/Contatos';
import Colegio from './Pages/Uniexpo-no-seu-colegio';
import Expositor from './Pages/Seja-um-expositor';
import TermosDeUso from './Pages/Termos-de-uso';
import PoliticaDePrivacidade from './Pages/Politica-de-privacidade';
import NotFound from './NotFound';

const SiteRoutes = ({initialData} : any) => (
  <Routes>
    <Route path="/" element={<Home initialData={initialData} />} />
    <Route path="/agenda-de-eventos" element={<EventosListagem initialData={initialData} />} />
    <Route path="/agenda-de-eventos/:evento" element={<EventosIntegra initialData={initialData} />} />
    <Route path="/palestra/:name" element={<PalestranteIntegra initialData={initialData} />} />
    <Route path="/eventos-realizados" element={<EventosAnterioresListagem />} />
    <Route path="/blog" element={<BlogListagem initialData={initialData} />} />
    <Route path="/blog/:news" element={<BlogIntegra initialData={initialData} />} />
    <Route path="/quem-somos" element={<Sobre initialData={initialData} />} />
    <Route path="/contatos" element={<Contatos />} />
    <Route path="/uniexpo-no-seu-colegio" element={<Colegio initialData={initialData} />} />
    <Route path="/seja-um-expositor" element={<Expositor initialData={initialData} />} />

    <Route path="/termos-de-uso" element={<TermosDeUso initialData={initialData} />} />
    <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade initialData={initialData} />} />

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default SiteRoutes;